import './ZeroState.scss';

import React from 'react';

import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import {
  GVAZeroState,
  GVAZeroStateV2
} from 'services/Content';
import { AAMBeaconButton } from 'components/shared/Beacon';
import { gvaNewCopyEnabled } from 'services/FeatureFlags';

const ZeroState = ({ addNewUser }) => (
  <PreferencesSection className="grant-view-access" fullBackground>
    <PreferencesRow className="document-delivery-preferences-row">
      <div className="gva-main-content">
        <div className="grant-view-access-zero-state">
          <p className="title">
            {gvaNewCopyEnabled() ? GVAZeroStateV2.Title : GVAZeroState.Title}
          </p>
          <p className="subtitle">{gvaNewCopyEnabled() ? GVAZeroStateV2.Subtitle : GVAZeroState.Subtitle}</p>
           {gvaNewCopyEnabled() ? GVAZeroStateV2.Content : GVAZeroState.Content}
            <div className="add-gva-user">
              <AAMBeaconButton
                id="add-new-user"
                onBeaconEventClick={addNewUser}
                variant="primary"
              >
                Add a User
              </AAMBeaconButton>
          </div>
        </div>
      </div>
    </PreferencesRow>
  </PreferencesSection>
);

export default ZeroState;
